<template>
  <base-material-card
    color="primary"
    icon="mdi-file-upload-outline"
    inline
    class="px-5 py-5"
  >
    <template v-slot:after-heading>
      <div class="display-1 font-weight-light">
        Nova Unitização
      </div>
    </template>

    <v-form class="pt-5">
      <v-row class="mx-4">
        <v-col cols="12">
          <v-alert
            dense
            outlined
            type="info"
          >
            O upload será processado em segundo plano. Envie o arquivo completo da consulta e preencha a aba
            <strong>Modelo Upload</strong>, mantendo também a aba <strong>Chaves com Saldo</strong> no mesmo arquivo.
          </v-alert>
        </v-col>
      </v-row>

      <v-row
        align="center"
        no-gutters
        class="mx-4"
      >
        <v-col cols="12">
          <v-text-field
            id="titulo-log-unitizacao-upload"
            v-model="titulo"
            label="Título*"
            outlined
            :error-messages="fieldErrors.titulo"
          />
        </v-col>
      </v-row>

      <v-row
        align="center"
        no-gutters
        class="mx-4"
      >
        <v-col cols="12">
          <v-file-input
            v-model="arquivoUploadFileObj"
            id="arquivo-log-unitizacao-upload"
            label="Arquivo da Consulta (.xlsx)*"
            placeholder="Selecione o arquivo preenchido"
            outlined
            accept=".xlsx"
            truncate-length="35"
            loader-height="4"
            :loading="arquivoUploadUploading"
            :success="!!(arquivoUploadId && arquivoUploadFileObj)"
            :error-messages="fieldErrors.arquivo_upload_id"
            @change="uploadNewFile"
            @click:clear="clearArquivoUpload"
          />
        </v-col>
      </v-row>

      <v-row
        v-if="arquivoUploadId"
        class="mx-4 mt-n2"
      >
        <v-col cols="12">
          <v-alert
            dense
            outlined
            type="success"
          >
            Arquivo enviado com sucesso e pronto para processamento.
          </v-alert>
        </v-col>
      </v-row>
    </v-form>
  </base-material-card>
</template>

<script>
import LogUnitizacaoService from '@/services/LogUnitizacaoService';

export default {
  name: 'LogUnitizacaoParametrosUpload',

  data() {
    return {
      titulo: '',
      arquivoUploadId: null,
      arquivoUploadFileObj: null,
      arquivoUploadUploading: false,
      fieldErrors: {
        titulo: [],
        arquivo_upload_id: []
      }
    };
  },

  watch: {
    titulo() {
      this.fieldErrors.titulo = [];
      this.notifyValidationChange();
    },

    arquivoUploadId() {
      this.notifyValidationChange();
    },

    arquivoUploadUploading() {
      this.notifyValidationChange();
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.notifyValidationChange();
    });
  },

  methods: {
    exportData() {
      const isTituloValido = this.validateTitulo(true);
      const isArquivoValido = this.validateArquivoUpload(true);

      if (!isTituloValido || !isArquivoValido) {
        throw new Error(this.getFirstValidationMessage());
      }

      return {
        nome: this.titulo.trim(),
        arquivo_upload_id: this.arquivoUploadId
      };
    },

    validateTitulo(showError = true) {
      const isValid = !!this.titulo.trim();

      if (!isValid && showError) {
        this.fieldErrors.titulo = ['É necessário preencher o título do lote.'];
      }

      return isValid;
    },

    validateArquivoUpload(showError = true) {
      const isValid = !!this.arquivoUploadId && !this.arquivoUploadUploading;

      if (!isValid && showError) {
        this.fieldErrors.arquivo_upload_id = ['Envie o arquivo .xlsx preenchido antes de registrar o lote.'];
      }

      return isValid;
    },

    validate() {
      return this.validateTitulo(false) && this.validateArquivoUpload(false);
    },

    notifyValidationChange() {
      this.$nextTick(() => {
        this.$emit('validation-change', this.validate());
      });
    },

    clearArquivoUpload() {
      this.arquivoUploadId = null;
      this.arquivoUploadFileObj = null;
      this.fieldErrors.arquivo_upload_id = [];
    },

    uploadNewFile(arquivo) {
      if (!arquivo) {
        this.clearArquivoUpload();
        return;
      }

      if (!/\.xlsx$/i.test(arquivo.name || '')) {
        this.clearArquivoUpload();
        this.fieldErrors.arquivo_upload_id = ['Apenas arquivos com extensão .xlsx são aceitos.'];
        this.$toast.error('Apenas arquivos .xlsx são aceitos.', '', { position: 'topRight' });
        return;
      }

      this.fieldErrors.arquivo_upload_id = [];
      this.arquivoUploadId = null;
      this.arquivoUploadUploading = true;

      const formDataWithFile = new FormData();
      formDataWithFile.append('file', arquivo);

      LogUnitizacaoService.uploadFile(formDataWithFile)
        .then((response) => {
          this.arquivoUploadId = response.data.arquivoUploadId;
          this.$toast.success('Arquivo enviado com sucesso.', '', { position: 'topRight' });
        })
        .catch((error) => {
          this.arquivoUploadId = null;
          this.arquivoUploadFileObj = null;
          this.fieldErrors.arquivo_upload_id = [this.getUploadErrorMessage(error)];
          this.$toast.error(this.getUploadErrorMessage(error), '', { position: 'topRight' });
          console.error(error);
        })
        .finally(() => {
          this.arquivoUploadUploading = false;
        });
    },

    getFirstValidationMessage() {
      const fields = ['titulo', 'arquivo_upload_id'];

      for (let i = 0; i < fields.length; i += 1) {
        const errors = this.fieldErrors[fields[i]];
        if (errors && errors.length > 0) {
          return errors[0];
        }
      }

      return 'Existem campos obrigatórios pendentes no formulário.';
    },

    getUploadErrorMessage(error) {
      if (error && error.response && error.response.data && error.response.data.erro) {
        return error.response.data.erro;
      }

      if (error && error.data && error.data.erro) {
        return error.data.erro;
      }

      return 'Erro no upload do arquivo.';
    }
  }
};
</script>
